export { default } from './DetailSteps';
